import { ChangeNameApp, ChangePasswordApp, ChangeSecretQuestionApp, ConnectedAccountsApp, DefaultsApp, EmailSettingsApp, FavoriteSubjectsApp, FeatureConfigSettingsApp, ICalendarFeedsApp, LanguageAndRegionApp, NotificationSettingsApp, SignatureSettingsApp } from "personalsettings/app";
import {
  type RouteObject,
} from "react-router";
import { PersonalSettingsMenuPage } from "SettingsMenuPage/SettingsMenuPage";

declare let viewModel: any;

export const personalSettingsRoute: RouteObject = {
  path: "personalsettings",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: PersonalSettingsMenuPage,
  }, {
    path: "change-name",
    loader: () => viewModel,
    Component: ChangeNameApp,
  }, {
    path: "change-password",
    loader: () => viewModel,
    Component: ChangePasswordApp,
  }, {
    path: "change-secret-question",
    loader: () => viewModel,
    Component: ChangeSecretQuestionApp,
  }, {
    path: "connected-accounts",
    loader: () => viewModel,
    Component: ConnectedAccountsApp,
  }, {
    path: "favorite-subjects",
    loader: () => viewModel,
    Component: FavoriteSubjectsApp,
  }, {
    path: "email-settings",
    loader: () => viewModel,
    Component: EmailSettingsApp,
  }, {
    path: "signature-settings",
    loader: () => viewModel,
    Component: SignatureSettingsApp,
  }, {
    path: "icalendar-feeds",
    loader: () => viewModel,
    Component: ICalendarFeedsApp,
  }, {
    path: "language-and-region",
    loader: () => viewModel,
    Component: LanguageAndRegionApp,
  }, {
    path: "notification-settings",
    loader: () => viewModel,
    Component: NotificationSettingsApp,
  }, {
    path: "defaults",
    loader: () => viewModel,
    Component: DefaultsApp,
  }, {
    path: "feature-configure",
    loader: () => viewModel,
    Component: FeatureConfigSettingsApp,
  }]
};